var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTailoredFeature4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 247.25 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#019cae;}.cls-2{fill:#c0cdea;}.cls-3{opacity:0.1;}.cls-3,.cls-5{isolation:isolate;}.cls-4{fill:#fff;}.cls-5{fill:#fdfeff;opacity:0.4;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_878",
    "data-name": "Group 878"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1787",
    "data-name": "Rectangle 1787",
    className: "cls-1",
    x: 37.63,
    y: 40.23,
    width: 171.98,
    height: 69.49
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1788",
    "data-name": "Rectangle 1788",
    className: "cls-2",
    x: 34.02,
    y: 44.06,
    width: 3.62,
    height: 65.65
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1789",
    "data-name": "Rectangle 1789",
    className: "cls-2",
    x: 209.61,
    y: 44.06,
    width: 3.62,
    height: 65.65
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1790",
    "data-name": "Rectangle 1790",
    className: "cls-3",
    x: 37.63,
    y: 40.23,
    width: 171.98,
    height: 69.49
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1791",
    "data-name": "Rectangle 1791",
    className: "cls-4",
    x: 44.85,
    y: 100.88,
    width: 13.03,
    height: 4.05
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1792",
    "data-name": "Rectangle 1792",
    className: "cls-5",
    x: 37.63,
    y: 44.06,
    width: 171.98,
    height: 6.73
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1793",
    "data-name": "Rectangle 1793",
    className: "cls-5",
    x: 37.63,
    y: 53.83,
    width: 171.98,
    height: 2.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_194",
    "data-name": "Ellipse 194",
    className: "cls-4",
    cx: 195.88,
    cy: 64.26,
    r: 4.63
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1794",
    "data-name": "Rectangle 1794",
    className: "cls-2",
    x: 78.65,
    y: 0.85,
    width: 89.95,
    height: 39.38
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1795",
    "data-name": "Rectangle 1795",
    className: "cls-4",
    x: 190.74,
    y: 71.83,
    width: 10.28,
    height: 1.48
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1796",
    "data-name": "Rectangle 1796",
    className: "cls-4",
    x: 190.74,
    y: 74.65,
    width: 10.28,
    height: 1.48
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailoredFeature4);
export default __webpack_public_path__ + "static/media/tailoredFeature4.8c17ae53df91cf3278ebb6dcb30491ce.svg";
export { ForwardRef as ReactComponent };